<template>
  <div>
    <h1 class="text-h1 pb-16">{{ headerText }}</h1>
    <div v-if="subheaderText" class="flex items-start gap-8 mb-16">
      <span v-if="showSubheaderIcon" class="text-20 leading-none flex-shrink-0">💡</span>
      <p class="text-body leading-6" v-html="subheaderText" />
    </div>
    <NoteBox header="What's next?">
      <ol class="leading-8 text-body-2 list-decimal pl-20 mt-8">
        <span v-if="reviewCopyTestEnabled" class="space-y-8">
          <li>Review and share your needs for free</li>
          <li>Interested sitters will reach out</li>
          <li v-if="isBasic">Upgrade to Premium to move forward with your matches</li>
          <li v-else>Connect with sitters who meet your needs</li>
        </span>
        <span v-else class="space-y-8">
          <li>Confirm the details and we'll share your job with local sitters</li>
          <li>Interested sitters will respond to your job</li>
          <li v-if="isBasic">Upgrade to Premium to directly connect with sitters</li>
          <li v-else>Connect with sitters who meet your needs</li>
        </span>
      </ol>
    </NoteBox>
  </div>
</template>

<script>
import NoteBox from '@/components/note_box/NoteBox.vue';

export default {
  name: 'JobPostConfirmTransitionText',
  components: {
    NoteBox,
  },
  props: {
    isAiGenerated: {
      type: Boolean,
      default: false,
    },
    reviewCopyTestEnabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isBasic() {
      return this.$store.getters['account/getAccount'].isBasic?.() || false;
    },
    headerText() {
      if (this.reviewCopyTestEnabled) {
        return 'Great work! Let’s share your needs with sitters';
      }

      return 'Great work! Your job is ready to share';
    },
    showSubheaderIcon() {
      return this.reviewCopyTestEnabled;
    },
    subheaderText() {
      if (this.reviewCopyTestEnabled) {
        return 'Families who share their needs are <strong>2.5x</strong> more likely to find a match.';
      }
      if (this.isAiGenerated) {
        return "We've generated a title and description to make it easier";
      }

      return '';
    },
  },
};
</script>
